import { ThemeService } from "@aecom/core";
import { Component, HostListener, OnInit, inject } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import environment from "src/environments/environment";
import { AuthService } from "@bbj/components";
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
  standalone: false,
})
export default class AppComponent implements OnInit {
  router = inject(Router);
  authService = inject(AuthService);
  themeService = inject(ThemeService);
  activateRoute = inject(ActivatedRoute);

  mainHeight: number;

  isIframe = false;

  @HostListener("window:resize")
  onResize(): void {
    this.mainHeight = window.innerHeight;
  }

  ngOnInit(): void {
    this.isIframe = window !== window.parent && !window.opener;
    this.authService.initService(
      environment.stage,
      environment.azureNew.tenantId,
    );
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;

    this.themeService.setActiveFullTheme("light");
    this.mainHeight = window.innerHeight;
  }
}
